import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TslToastrService } from '@tesla/ng-tds';
import { DomainEditComponent } from 'app/common/domain/domain-edit.component';
import { EmailDomain } from 'app/profile/models/supplier.model';
import { I18nService } from 'app/shared/services/i18n.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-domain-task-dialog',
  templateUrl: './domain-task-dialog.component.html',
  styleUrls: ['./domain-task-dialog.component.scss']
})
export class DomainTaskDialogComponent implements OnInit {
  @ViewChild('domainEdit', { static: false }) domainEditComponent: DomainEditComponent;

  supplierCode: string;
  emailDomain: EmailDomain = new EmailDomain();
  domainDifferenceReasons$: Observable<string[]>;
  existingDomains: string[];

  constructor(
    public dialogRef: MatDialogRef<DomainTaskDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private toaster: TslToastrService,
    private translate: I18nService
  ) { }

  ngOnInit(): void {
    this.supplierCode = this.data?.supplierCode;
    this.emailDomain = this.data?.emailDomain;
    this.domainDifferenceReasons$ = this.data?.domainDifferenceReasons$;
    this.existingDomains = this.data?.existingDomains;
  }

  setErrorMessage(message) {
    if (message) this.toaster.error((message && message.trim() != '') ? message : this.translate.get('Something went wrong!'));
  }

  emailDomainSubmit(domain: EmailDomain) {
    if (domain) {
      this.dialogRef.close(domain);
    } else this.toaster.error(this.translate.get('Something went wrong!'));
  }

  onSubmit() {
    this.domainEditComponent.submit();
  }

  onClose() {
    this.dialogRef.close();
  }
}
